
import { defineComponent } from 'vue'
import global from '@/utils/global'
import { getCompanyListParamApi } from '@/api/long-insure'
import { applyOccupationApi, addPeriodServeCompanyAndApplyOccupationApi, reApplyOccupationApi } from '@/api/long-insure-new'
import { addBindCompanySupplier } from '@/api/home'
import popupTeamMember from '@/components/popup-team-member.vue'
import popupEnterprise from '@/components/popup-enterprise.vue'

export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false
    },
    // 申请新工种时传入
    curCompanyId: {
      type: [Number, String]
    },
    id: {
      type: [Number, String]
    },
    readdId: {
      type: [Number, String]
    },
    // add：添加被派遣单位 apply：申请新工种
    addType: {
      type: String,
      default: 'add'
    },
    // 保险类型 2：安心保、 8：安心日保
    insureType: {
      type: [Number, String],
      default: 2
    }
  },
  components: {
    popupTeamMember,
    popupEnterprise
  },
  data() {
    return {
      showDialog: false,
      isfileLengt: true,
      companyList: [] as any, // 所有单位
      Authorization: 'Bearer' + ' ' + global.token,
      uploadAction: process.env.VUE_APP_BASE_URL + '/rest/period-insur/serve-company/upload',
      fileSize: '',
      fileUrl: [] as any,
      companyId: '' as any,
      disabled: false,
      isEnterprise: false,
      headList: [],
      isPopupTeamMember: false
    }
  },
  watch: {
    async show(newval) {
      this.showDialog = newval
      if (newval) {
        await this.getCompanyList()
        this.setDefaultCompany()
      }
    },
    showDialog(newval) {
      this.$emit('update:show', newval)
      if (!newval) {
        this.fileUrl = []
        this.fileSize = ''
      }
    }
  },
  computed: {
    titleName() {
      return this.addType === 'apply' ? '申请新工种' : '新增派遣单位'
    }
  },
  async created() {
    await this.getCompanyList()
  },
  methods: {
    setDefaultCompany() {
      if (this.addType === 'apply' || this.addType === 'reapply') {
        this.companyId = parseInt(this.curCompanyId as string)
        this.disabled = true
      } else {
        this.companyId = ''
        this.disabled = false
      }
    },
    // 获取所有单位列表
    async getCompanyList() {
      const result = await getCompanyListParamApi({ excludeFast: true })
      console.log(result, 'result获取所有单位列表')
      this.companyList = result.list
    },
    async fileBeforeUpload(file: any) {
      var url = URL.createObjectURL(file)
      var audioElement = new Audio(url)
      var duration = parseInt(audioElement.duration + '')
      audioElement.addEventListener('loadedmetadata', () => {
        console.log(parseInt(audioElement.duration + ''), '时长为秒，取整') // 时长为秒，取整
        const fileLength = parseInt(audioElement.duration + '')
        if (file.size / 1024 / 1024 > 100) {
          this.$message.error('视频不可大于100M')
          this.isfileLengt = false
          return
        }
        if (fileLength < 10 && fileLength > 60) {
          this.$message.error('视频不可小于10秒或大于60秒')
          this.isfileLengt = false
          return
        }
      })
    },
    fileSuccess(
      response: { code: number; msg: string; data: { fileSize: string; fileUrl: string } },
      file: {
        raw: { name: string; type: string }
      }
    ) {
      console.log(file.raw, 'file.raw')
      if (response.code === 500) {
        this.$message.error(response.msg)
        return
      }
      if (file.raw.type !== 'video/mp4') {
        this.$message.error('请上传视频')
        return
      }
      // if (!this.isfileLengt) {
      //     this.$message.error('视频不可小于10秒或大于100秒')
      //     return
      // }
      this.fileSize = response.data.fileSize
      this.fileUrl.push(response.data.fileUrl)
      this.$message.success('上传成功')
    },
    fileEerror() {
      this.$message.error('文件上传失败')
    },
    // 派遣单位
    async addDispatchUnit() {
      if (this.fileUrl.length === 0) {
        this.$message.error('请至少上传一个视频')
        return
      }
      console.log('add派遣单位', {
        insureType: this.insureType,
        serveCompanyId: Number(this.companyId),
        fileUrls: this.fileUrl
      })
      const result = await addPeriodServeCompanyAndApplyOccupationApi({
        insureType: this.insureType,
        serveCompanyId: Number(this.companyId),
        fileUrls: this.fileUrl
      })
      this.showDialog = false
      this.$emit('success')
      this.$message.success('提交被派遣单位成功')
    },
    // 添加企业
    onAddCompany() {
      console.log('添加企业')
      this.isEnterprise = true
    },
    // 打开选择负责人弹窗
    onSelectHead() {
      this.isPopupTeamMember = true
    },
    // 确认添加企业回调
    async onAddEnterprise(head: any, enterprise: any, phone: string, switchCard: boolean, isAdvance: any, isPhone: any) {
      console.log(head, enterprise, phone, switchCard)
      // const query = {
      //     area: enterprise.area || '暂无', // 公司位置
      //     contacts: head[0].userName, // 选择的name
      //     contactsId: head[0].userId, // 选择的id
      //     createUserId: 2, // user.userId
      //     creditCode: enterprise.creditCode,
      //     isNeedIdcardPhoto: switchCard ? 1 : 0, // 是否需要照片
      //     phone: phone, // 电话
      //     serveCompanyName: enterprise.name, // 公司名称
      //     isOpenAdvance: isAdvance * 1,
      //     isShowContacts: isPhone * 1
      // }
      addBindCompanySupplier({
        area: enterprise.area || '暂无', // 公司位置
        contacts: head[0].userName, // 选择的name
        contactsId: head[0].userId, // 选择的id
        createUserId: 2, // user.userId
        creditCode: enterprise.creditCode,
        isNeedIdcardPhoto: switchCard ? 1 : 0, // 是否需要照片
        phone: phone, // 电话
        serveCompanyName: enterprise.name, // 公司名称
        isOpenAdvance: isAdvance * 1,
        isShowContacts: isPhone * 1
      })
        .then(() => {
          this.isEnterprise = false
          this.$message.success('创建成功')
          // 刷新派遣单位数据
          this.getCompanyList()
        })
        .catch(() => {
          this.isEnterprise = true
        })
    },
    // 选择负责人回调
    async onAddHead(event: any) {
      console.log(event, 'event')
      this.headList = event
      console.log(this.headList, 'headList')
      this.isPopupTeamMember = false
    },
    async onSubmit() {
      if (this.addType === 'apply') {
        // 申请新工种
        if (this.fileUrl.length === 0) {
          this.$message.error('请至少上传一个视频')
          return
        }
        const result = await applyOccupationApi({
          periodServeCompanyId: Number(this.id),
          fileUrls: this.fileUrl
        })
        this.showDialog = false
        this.$emit('success')
        this.$message.success('申请新工种成功')
      } else if (this.addType === 'reapply') {
        if (this.fileUrl.length === 0) {
          this.$message.error('请至少上传一个视频')
          return
        }
        const result = await reApplyOccupationApi({
          occupationApplyRecordId: Number(this.readdId),
          fileUrls: this.fileUrl
        })
        this.showDialog = false
        this.$emit('success')
        this.$message.success('申请新工种成功')
      } else {
        // 添加被派遣单位
        this.addDispatchUnit()
      }
      this.$emit('success')
    }
  }
})
